<script setup lang="ts">
import type { HtmlParserPlugins } from '~/plugins/dom-parser'
import type { SectionLayout } from '~/utils/journals/section-layout'
import SectionTitleWithFootnote from '~/components/journals/SectionTitleWithFootnote.vue'
import { useFootnoteClickHandler } from '~/composables/footnotes/useFootnoteClickHandler'

const props = defineProps<{
  layout: SectionLayout
  footnotes?: FootnotesState
}>()

const emit = defineEmits<{
  openFootnote: [id: string]
  closeFootnote: [id: string]
}>()

const { handleClick } = useFootnoteClickHandler({
  footnotes: () => props.footnotes,
  open: (id: string) => emit('openFootnote', id),
  close: (id: string) => emit('closeFootnote', id),
})

const footnoteParserConfig = computed(() =>
  props.footnotes
    ? {
        plugins: [
          'setup-journal-footnote-containers',
          'insert-footnotes',
        ] as HtmlParserPlugins,
        options: {
          content: Object.values(props.footnotes)
            .filter(it => it.open)
            .map(it => it.content),
        },
      }
    : undefined,
)
</script>

<template>
  <SectionTitleWithFootnote
    v-if="layout.title"
    :title="layout.title"
    :section-id="layout.id"
  />
  <BodyText
    v-if="layout.html"
    class="grow"
    :html="layout.html"
    :parser-config="footnoteParserConfig"
    @click="handleClick"
  />
</template>
